// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".modal-container .modal-footer[data-v-630838d1]{padding:var(--space-normal) var(--space-medium)}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/widgets/modal/ConfirmationModal.vue"],"names":[],"mappings":"AACA,gDACE,+CAAA","file":"ConfirmationModal.vue","sourcesContent":["\n.modal-container .modal-footer {\n  padding: var(--space-normal) var(--space-medium);\n}\n"]}]);
// Exports
module.exports = exports;
